import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('#advert-gallery-preview-slide')) {
        return;
    }
 
    const advertGalleryPreviewSlide = new Splide('#advert-gallery-preview-slide', {
        perPage: 1,
        perMove: 1,
        loop: false,
        pagination: false,
        arrows: false,
        autoplay: false,
        lazyLoad: "nearby",
        preloadPages: 0,
    });

    const advertGalleryThumbnailsSlide = new Splide('#advert-gallery-thumbnails-slide', {
        perPage: 6,
        perMove: 1,
        rewind: false,
        arrows: true,
        autoplay: false,
        drag: true,
        isNavigation: true,
        gap: 0,
        focus: 'center',
        pagination: false,
        lazyLoad: "nearby",
        preloadPages: 0,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
        breakpoints: {
            800: {
                perPage: 4,
            },
        },
    });

    advertGalleryPreviewSlide.sync(advertGalleryThumbnailsSlide);

    advertGalleryPreviewSlide.mount()
    advertGalleryThumbnailsSlide.mount();
});